import { baseUrl } from "./baseUrl";
import buildUrl from "../utils/buildUrl";

export const linksCreateRoute = (params: { linkTypeAlias: string }) =>
  buildUrl({
    url: `${baseUrl}/dict-api/links`,
    searchParams: params,
  });

export const linksDeleteRoute = (params: { linkTypeAlias: string; fromId: number; toId: number }) =>
  buildUrl({
    url: `${baseUrl}/dict-api/links`,
    searchParams: params,
  });
